export const APPLE_PAY_CONSTRUCT_PAYMENT_REQUEST = 'APPLE_PAY_CONSTRUCT_PAYMENT_REQUEST'
export const APPLE_PAY_SET_LOADING = 'APPLE_PAY_SET_LOADING'
export const APPLE_PAY_SET_ADDRESS_VALIDATION_DATA = 'APPLE_PAY_SET_ADDRESS_VALIDATION_DATA'
export const APPLE_PAY_SET_FROM_PAGE_MARK = 'APPLE_PAY_SET_FROM_PAGE_MARK'
export const APPLE_PAY_SET_STRATEGY = 'APPLE_PAY_SET_STRATEGY'

export const mutations = {
  [APPLE_PAY_SET_STRATEGY]: (state, strategy) => {
    state.strategy = Object.assign(state.strategy, strategy)
  },
  [APPLE_PAY_SET_FROM_PAGE_MARK]: (state, mark) => {
    state.fromPageMark = mark
  },
  [APPLE_PAY_CONSTRUCT_PAYMENT_REQUEST]: (state, { data }) => {
    state.orderId = data.orderId
    state.defaultShippingModeId = data.defaultShipModeId
    state.countryCode = data.countryCode
    state.paymentRequest = state.strategy.makePaymentRequestObject(data)
  },
  [APPLE_PAY_SET_LOADING]: (state, loading) => {
    state.loading = loading
  },
  [APPLE_PAY_SET_ADDRESS_VALIDATION_DATA]: (state) => {
    state.shippingContactValidationRules = {
      phoneNumber: {
        isValueRequired: true,
      },
      emailAddress: {
        isValueRequired: true,
      },
    }
    state.shippingAddressInitialValidationRules = {
      locality: {
        isRegexRequired: false,
        pattern: '^[^0-9]+$',
        isValueRequired: true,
      },
      administrativeArea: {
        isRegexRequired: false,
        pattern: '^[^0-9]+$',
        isValueRequired: true,
      },
      postalCode: {
        isRegexRequired: false,
        pattern: state.zipcodePatternsMap[self.countryCode],
        isValueRequired: true,
      },
    }
    state.shippingAddressFinalValidationRules = {
      givenName: {
        isRegexRequired: false,
        pattern: '^[^0-9]+$',
        isValueRequired: true,
      },
      familyName: {
        isRegexRequired: false,
        pattern: '^[^0-9]+$',
        isValueRequired: true,
      },
      addressLines: [
        {
          isRegexRequired: false,
          pattern: '',
          isValueRequired: true,
        },
        {
          isRegexRequired: false,
          pattern: '',
          isValueRequired: false,
        },
      ],
    }
    state.billingAddressValidationRules = {
      givenName: {
        isValueRequired: true,
      },
      familyName: {
        isValueRequired: true,
      },
      addressLines: [
        {
          isValueRequired: true,
        },
        {
          isValueRequired: false,
        },
      ],
      locality: {
        isValueRequired: true,
      },
      administrativeArea: {
        isValueRequired: true,
      },
      postalCode: {
        isValueRequired: true,
      },
    }
  },
}
